import { render, staticRenderFns } from "./CashierSelectedElement.vue?vue&type=template&id=013f04cc&scoped=true"
import script from "./CashierSelectedElement.vue?vue&type=script&lang=js"
export * from "./CashierSelectedElement.vue?vue&type=script&lang=js"
import style0 from "./CashierSelectedElement.vue?vue&type=style&index=0&id=013f04cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f04cc",
  null
  
)

export default component.exports